const Close = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.8438 11.1562L11.1562 39.8438"
        stroke="#ff3b24"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8438 39.8438L11.1562 11.1562"
        stroke="#ff3b24"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Close;
